<template>
    <div class="administration">
        <UsersTable />
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import UsersTable from '@/components/administration/UsersTable.vue';

export default {
    name: 'Administration',
    components: {
        UsersTable
    },
    computed: {
        ...mapState('users', ['userList'])
    },
    methods: {
        // ...mapActions('users', ['getUserList'])
        ...mapActions('users', [
            // 'getRoleList',
            'getServOrgList',
            'saveUser',
            'newUser',
            'getUserList',
            'getContractList',
            'getKSKList',
            'getCategoryList',
            'getRolesCategoryList',
            'getEngList'
        ])
    },
    async created() {
        // await this.getRoleList();
        // dispatches in getUserList() (Users module)
        // TODO: проверить и отрефакторить, до этого вызов закоментирован
        // await this.getServOrgList();
        await this.getContractList();
        await this.getKSKList();
        await this.getCategoryList();
        await this.getRolesCategoryList();
        await this.getEngList();
    }
};
</script>
